import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WAccountWebsiteEffectsView } from '@zola/svc-web-api-ts-client';

export const getAppliedAnimations = () =>
  ApiService.get<WAccountWebsiteEffectsView>('/web-api/v1/website-effect');
